import React, { Component } from 'react';
import Base from './Base';
import { Header } from './Header';

export default class DragDropComponent extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            items1: ['دریافت ردیف پیمان ', 'دریافت بخشودگی', 'ارسال گزارش ارزش افزوده '],
            items2: ['مالیات حقوق مهر', 'رسیدگی', 'پرداخت بیمه'],
            draggedItem: null,
            sourceList: null
        };
    }




    onDragStart = (event, item, sourceList) => {
        this.setState({ draggedItem: item, sourceList });
        event.dataTransfer.effectAllowed = 'move';
    }
    onDrop = (targetList) => {
        const { draggedItem, sourceList } = this.state;

        if (sourceList === targetList) {
            return;
        }

        this.setState(prevState => {
            let newSourceList = [...prevState[sourceList]];
            let newTargetList = [...prevState[targetList]];

            newSourceList = newSourceList.filter(i => i !== draggedItem);
            newTargetList.push(draggedItem);

            return {
                [sourceList]: newSourceList,
                [targetList]: newTargetList,
                draggedItem: null,
                sourceList: null
            };
        });
    }
    onDragOver = (event) => {
        event.preventDefault();
    }
    renderList = (items, listName) => {
        return items.map((item, index) => (
            <li
                key={index}
                draggable
                onDragStart={(event) => this.onDragStart(event, item, listName)}
                style={{ padding: '8px', margin: '4px', border: '1px solid #ccc', cursor: 'move' }}
            >
                {item}
            </li>
        ));
    }

    render() {

        return (

            <div className="m-2">
                <ul className="row g-gs">
                    <li className="col-lg-3 col-6 col-sm-4">        
                <div

                    onDragOver={this.onDragOver}
                    onDrop={() => this.onDrop('items1')}
                    style={{ width: '100%', padding: '20px', border: '1px solid #ccc', minHeight: '200px' }}
                >
                    <h4>درحال انجام</h4>
                    <ul>{this.renderList(this.state.items1, 'items1')}</ul>
                        </div>
                    </li>
                    <li className="col-lg-3 col-6 col-sm-4">    
                <div

                    onDragOver={this.onDragOver}
                    onDrop={() => this.onDrop('items2')}
                    style={{ width: '100%', padding: '20px', border: '1px solid #ccc', minHeight: '200px' }}
                >
                    <h4>انجام شده</h4>
                    <ul>{this.renderList(this.state.items2, 'items2')}</ul>
                </div>

                    </li>
                </ul>
            </div>
        );
    }
}

